export function setBackground(backgroundUrl: string) {
    const styleString = (`
        :root {
        --background-image: url(${backgroundUrl});
        }
    `)
    const style = document.createElement("style")
    style.textContent = styleString
    document.head.append(style)
}